import FlavourConfig from '../config/flavours';

const TRACK_SETTINGS_KEY = 'track_settings';

const Storage = {
  get: (key: string) => {
    return localStorage.getItem(`${FlavourConfig.appName}_${key}`);
  },
  set: (key: string, value: string) => {
    localStorage.setItem(`${FlavourConfig.appName}_${key}`, value);
  },
  delete: (key: string) => {
    localStorage.removeItem(`${FlavourConfig.appName}_${key}`);
  },
};

export { TRACK_SETTINGS_KEY };
export default Storage;
